<div *transloco="let t">
	<div [class.container]="isVerticalLayout()" class="toolbar w-full px-gutter flex items-center">
		<button (click)="openSidenav()" [class.hidden]="!mobileQuery()" mat-icon-button>
			<mat-icon [svgIcon]="icons.get('menu')"></mat-icon>
		</button>

		@if (isVerticalLayout()) {
			<a [routerLink]="['/']" class="ltr:mr-4 rtl:ml-4 block flex flex-row items-start justify-center">
				<h1 [class.hidden]="!mobileQuery()" class="title ltr:pl-4 rtl:pr-4 m-0 select-none">VEX</h1>
			</a>
		}
		<div>
			@if (mobileQuery()) {
				<button mat-icon-button [matMenuTriggerFor]="quickActions" color="primary" (click)="$event.stopPropagation()">
					<mat-icon>quickreply</mat-icon>
				</button>
			} @else {
				<button mat-raised-button [matMenuTriggerFor]="quickActions" color="primary" (click)="$event.stopPropagation()">
					<div class="flex items-center gap-2">
						<mat-icon>menu</mat-icon>
						<span>{{ t('commonActions.quickActions') }}</span>
					</div>
				</button>
			}
			<mat-menu #quickActions="matMenu">
				<button mat-menu-item (click)="newTenantChange()">
					<mat-icon color="primary">person_edit</mat-icon>
					<div>{{ t('commonActions.tenantChange') }}</div>
				</button>
				<button mat-menu-item (click)="newVacancyChange()">
					<mat-icon color="primary" fontSet="material-symbols-outlined">door_open</mat-icon>
					<div>{{ t('commonActions.newVacancy') }}</div>
				</button>
				<button mat-menu-item (click)="changeUviPermission()">
					<mat-icon color="primary">shield_person</mat-icon>
					<div>{{ t('commonActions.changeUviPermission') }}</div>
				</button>
				<button mat-menu-item (click)="activateRealEstate()">
					<mat-icon color="primary">add</mat-icon>
					<div>{{ t('commonActions.activateRealEstate') }}</div>
				</button>
			</mat-menu>
		</div>
		<span class="flex-1"></span>

		<div class="px-1">
			<button (click)="jobStateService.openDialog()" mat-icon-button cdkOverlayOrigin #jobOverlay="cdkOverlayOrigin">
				<div>
					@if (jobStateService.allJobsFinished) {
						<mat-icon [svgIcon]="icons.get('downloading')" color="primary"></mat-icon>
					} @else {
						<mat-progress-spinner mode="indeterminate" [diameter]="30" color="primary"></mat-progress-spinner>
					}
				</div>
			</button>
		</div>

		<div class="px-1">
			@if (selectedLanguage() === 'en') {
				<button [matMenuTriggerFor]="languageMenu" mat-icon-button>
					<mat-icon [svgIcon]="icons.get('flagUS')"></mat-icon>
				</button>
			} @else {
				<!-- For now we only have EN and DE so it has to be de here-->
				<button [matMenuTriggerFor]="languageMenu" mat-icon-button>
					<mat-icon [svgIcon]="icons.get('flagDE')"></mat-icon>
				</button>
			}
		</div>

		<mat-menu #languageMenu="matMenu" overlapTrigger="false" xPosition="before" yPosition="below">
			<button mat-menu-item (click)="changeLanguage('en')">
				<mat-icon [svgIcon]="icons.get('flagUS')"></mat-icon>
				<span>{{ t('language.english') }}</span>
			</button>

			<button mat-menu-item (click)="changeLanguage('de')">
				<mat-icon [svgIcon]="icons.get('flagDE')"></mat-icon>
				<span>{{ t('language.german') }}</span>
			</button>
		</mat-menu>
		<vex-toolbar-user></vex-toolbar-user>
	</div>

	@if (isVerticalLayout() && isNavbarBelowToolbar()) {
		<vex-navigation [class.hidden]="mobileQuery()"></vex-navigation>
	}
	<ng-template
		cdkConnectedOverlay
		[cdkConnectedOverlayOrigin]="jobOverlay"
		[cdkConnectedOverlayOpen]="isOpen"
		[cdkConnectedOverlayHasBackdrop]="isOpen"
		[cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop-cs'"
		(backdropClick)="isOpen = !isOpen">
		<div class="flex flex-col">
			<div class="table-fixed-paginator-wrapper">
				<table [dataSource]="dataSource" class="mat-elevation-z8" mat-table [style]="isMobile ? 'min-width: 75%' : 'width: 500px'">
					<ng-container matColumnDef="startTime">
						<th *matHeaderCellDef mat-header-cell>{{ t('jobLog.startTime') }}</th>
						<td *matCellDef="let element" mat-cell>{{ element.startTime | date: 'dd.MM.yy HH:mm:ss' }}</td>
					</ng-container>

					<ng-container matColumnDef="jobType">
						<th *matHeaderCellDef mat-header-cell>{{ t('jobLog.jobType') }}</th>
						<td mat-cell *matCellDef="let element">{{ t('jobLogType.' + [element.jobType]) }}</td>
					</ng-container>

					<ng-container matColumnDef="percent">
						<th *matHeaderCellDef mat-header-cell>{{ t('jobLog.percent') }}</th>
						<td *matCellDef="let element" mat-cell>
							@if (element.jobStatus === JobStatusEnum.IN_PROGRESS) {
								<div>
									@if (element.percent === 0) {
										<mat-progress-spinner mode="indeterminate" [diameter]="30" color="primary"></mat-progress-spinner>
									}
									@if (element.percent !== 0) {
										<mat-progress-spinner
											mode="determinate"
											[value]="element.percent"
											[diameter]="30"
											color="primary"></mat-progress-spinner>
									}
								</div>
							}
							@if (element.jobStatus !== JobStatusEnum.IN_PROGRESS) {
								@if (element.jobStatus === JobStatusEnum.ERROR) {
									<mat-icon [svgIcon]="icons.get('warning')" [matTooltip]="element.errorMessage" color="warn"></mat-icon>
								}
								@if (element.jobStatus === JobStatusEnum.FINISHED) {
									<mat-icon [svgIcon]="icons.get('checkSmall')"></mat-icon>
								}
								@if (
									element.jobStatus === JobStatusEnum.FINISHED &&
									(element.jobType === JobTypeEnum.EED_PM_MASS_PRINT ||
										element.jobType === JobTypeEnum.EED_SC_MASS_PRINT ||
										element.jobType === JobTypeEnum.SMOKE_DETECTOR_INSPECTION_REPORT)
								) {
									<button color="primary" mat-icon-button (click)="downloadFileFromJobLog(element)">
										<mat-icon [svgIcon]="icons.get('fileDownload')"></mat-icon>
									</button>
								}
							}
						</td>
					</ng-container>

					<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
					<tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" colspan="4">
							<div class="ml-4">
								{{ t('jobLog.noDataFound') }}
							</div>
						</td>
					</tr>
				</table>
			</div>
			<ara-paginator
				(page)="getPaginatedData($event)"
				[pageSizeOptions]="pageSizeOptions"
				[showFirstLastButtons]="true"
				[length]="length"
				[pageIndex]="pageIndex"
				[pageSize]="pageSize"
				class="sticky left-0"></ara-paginator>
		</div>
	</ng-template>
</div>
